
export class ShopContact {
  contactType = '';
  info = '';

  constructor(contact = null) {
    if (contact) {
      this.contactType = contact.contactType || this.contactType;
      this.info = contact.info || this.info;
    }
  }
}
